export default [
  {
    path: '/creator/list',
    name: 'creator-list',
    component: () => import('@/views/creator/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Creator List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Creator' }, { title: 'Creator List', active: true }],
      permissions: ['creator_list']
    }
  },
  {
    path: '/creator/add',
    name: 'create-creator',
    component: () => import('@/views/creator/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Creator',
      parent: 'creatorList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Creator', url: '/creator/list' },
        { title: 'Add Creator', active: true }
      ],
      permissions: ['creator_create']
    }
  },
  {
    path: '/creator/:id/edit',
    name: 'edit-creator',
    component: () => import('@/views/creator/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Creator',
      parent: 'creatorList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Creator', url: '/creator/list' },
      //   { title: 'Edit Creator', active: true }
      // ],
      permissions: ['creator_edit']
    }
  },
  {
    path: '/creator/:id/analytics',
    name: 'analytics-creator',
    component: () => import('@/views/creator/analytics.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Creator Analytics',
      parent: 'creatorList',
      permissions: ['creator_analytics']
    }
  }
]
